/**
 * Reparo Interactions
 * - IntersectionObserver: adds `fade-in-visible` to `.fade-up` elements on scroll
 * - Countdown timer: initialises any element with class `reparo-countdown`
 */

// ---------------------------------------------------------------------------
// 1. Fade-up IntersectionObserver
// ---------------------------------------------------------------------------
function initFadeObserver() {
  const targets = document.querySelectorAll('.fade-up');
  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.05, rootMargin: '0px 0px -20px 0px' }
  );

  targets.forEach((el) => {
    // Immediately reveal elements already visible in the viewport
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.classList.add('fade-in-visible');
    } else {
      observer.observe(el);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFadeObserver);
} else {
  initFadeObserver();
}
document.addEventListener('shopify:section:load', initFadeObserver);

// ---------------------------------------------------------------------------
// 2. Countdown timer  (data-time="MM:SS")
// ---------------------------------------------------------------------------
(function initCountdowns() {
  const countdowns = document.querySelectorAll('.reparo-countdown');
  if (!countdowns.length) return;

  countdowns.forEach((el) => {
    // Skip elements that will be handled by their own section-level JS
    // (those already have a separate tick running — identified by data-time
    // being consumed by an inline script in the hero section).
    // We only initialise elements that have NOT already started ticking.
    if (el.dataset.managed) return;
    el.dataset.managed = '1';

    const raw = (el.dataset.time || '15:00').trim();
    const parts = raw.split(':').map(Number);
    let totalSeconds;

    if (parts.length === 3) {
      totalSeconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
    } else {
      totalSeconds = (parts[0] || 0) * 60 + (parts[1] || 0);
    }

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      if (totalSeconds <= 0) {
        el.textContent = '00:00';
        return;
      }
      const m = Math.floor(totalSeconds / 60);
      const s = totalSeconds % 60;
      el.textContent = pad(m) + ':' + pad(s);
      totalSeconds--;
      setTimeout(tick, 1000);
    }

    tick();
  });
})();

// ---------------------------------------------------------------------------
// 3. Intercept Releasit Buy Now click and redirect to custom checkout page
// ---------------------------------------------------------------------------
(function initReleasitRedirect() {
  document.addEventListener('click', function(e) {
    const target = e.target.closest('#_rsi-buy-now-button, #_rsi-buy-now-button-overwrite, [class*="releasit-cod-form-button"]');
    if (target) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = window.location.pathname + '?view=reparo-checkout';
    }
  }, true);
})();
